<!-- eslint-disable prettier/prettier -->
<mat-card appearance="outlined">
	<mat-card-content>

		@if (soloLectura) {

		<!-- ─── Vista resumen ──────────────────────────────────────────────── -->
		@if (addresses().length === 0) {
		<p class="addr-empty">Sin completar</p>
		} @else {
		<div class="addr-list">
			@for (addr of addresses(); track addr.tipoDomicilio) {
			<div class="addr-card">
				<span class="addr-card__tipo">{{ getTipoDomicilio(addr.tipoDomicilio) }}</span>
				<div class="addr-card__grid">
					<div class="info-field">
						<span class="info-field__label">Calle</span>
						<span class="info-field__value">{{ addr.calle }} {{ addr.numero }}</span>
					</div>
					<div class="info-field">
						<span class="info-field__label">Código postal</span>
						<span class="info-field__value">{{ addr.cp || '—' }}</span>
					</div>
					<div class="info-field">
						<span class="info-field__label">Localidad</span>
						<span class="info-field__value">{{ addr.localidad || '—' }}</span>
					</div>
					<div class="info-field">
						<span class="info-field__label">Partido</span>
						<span class="info-field__value">{{ addr.partido || '—' }}</span>
					</div>
					@if (addr.torre || addr.piso || addr.depto) {
					<div class="info-field">
						<span class="info-field__label">Torre</span>
						<span class="info-field__value">{{ addr.torre || '—' }}</span>
					</div>
					<div class="info-field">
						<span class="info-field__label">Piso / Depto</span>
						<span class="info-field__value">{{ addr.piso || '—' }} / {{ addr.depto || '—' }}</span>
					</div>
					}
				</div>
			</div>
			}
		</div>
		}

		} @else {

		<!-- ─── Vista edición ──────────────────────────────────────────────── -->

		<!-- Lista de domicilios -->
		@if (addresses().length > 0) {
		<div class="addr-list addr-list--edit">
			@for (addr of addresses(); track addr.tipoDomicilio; let i = $index) {
			<div class="addr-card" [class.addr-card--editing]="domicilioAEditarIndex() === i">
				<div class="addr-card__header">
					<span class="addr-card__tipo">{{ getTipoDomicilio(addr.tipoDomicilio) }}</span>
					<div class="addr-card__actions">
						<button mat-icon-button (click)="editarDomicilio(addr, i)" matTooltip="Editar">
							<lucide-icon name="pencil" [size]="16" [strokeWidth]="1.5" color="#131416"></lucide-icon>
						</button>
						<button mat-icon-button (click)="eliminarDomicilio(i)" matTooltip="Eliminar">
							<lucide-icon name="trash-2" [size]="16" [strokeWidth]="1.5" color="#131416"></lucide-icon>
						</button>
					</div>
				</div>
				<div class="addr-card__grid">
					<div class="info-field">
						<span class="info-field__label">Calle</span>
						<span class="info-field__value">{{ addr.calle }} {{ addr.numero }}</span>
					</div>
					<div class="info-field">
						<span class="info-field__label">Código postal</span>
						<span class="info-field__value">{{ addr.cp || '—' }}</span>
					</div>
					<div class="info-field">
						<span class="info-field__label">Localidad</span>
						<span class="info-field__value">{{ addr.localidad || '—' }}</span>
					</div>
					<div class="info-field">
						<span class="info-field__label">Partido</span>
						<span class="info-field__value">{{ addr.partido || '—' }}</span>
					</div>
				</div>
			</div>
			}
		</div>
		} @else {
		<p class="addr-empty">No hay domicilios registrados</p>
		}

		<!-- Formulario inline -->
		@if (modoEdicionDomicilio() || mostrarFormAgregar()) {
		<section class="address-form" [class.address-form--editing]="modoEdicionDomicilio()">
			<h3 class="address-form__title">
				{{ modoEdicionDomicilio() ? 'Editar domicilio' : 'Agregar domicilio' }}
			</h3>

			<form [formGroup]="addressForm">
				<div class="address-form__grid-top">
					<mat-form-field appearance="outline">
						<mat-label>Tipo de domicilio</mat-label>
						<mat-select formControlName="tipoDomicilio">
							@for (t of tiposDomicilioFiltered(); track t.id) {
							<mat-option [value]="t.id">{{ t.description }}</mat-option>
							}
						</mat-select>
					</mat-form-field>

					<mat-form-field appearance="outline">
						<mat-label>Calle y altura</mat-label>
						<input
							matInput
							formControlName="direccion"
							[matAutocomplete]="autoCallejero"
							[matAutocompleteDisabled]="!isVicenteLopez()"
							placeholder="Ej: Maipú 1234"
						/>
						@if (isLoadingCallejero()) {
						<mat-spinner matSuffix diameter="18" class="icon-callejero-loading"></mat-spinner>
						}
						<mat-autocomplete
							#autoCallejero
							[displayWith]="displayDireccion"
							(optionSelected)="onSeleccionarSugerencia($event.option.value)"
						>
							@for (s of callejeroSugerencias(); track s.place_id) {
							<mat-option [value]="s">{{ s.display_name }}</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>
				</div>

				<div class="address-form__grid-middle">
					<mat-form-field appearance="outline">
						<mat-label>Localidad</mat-label>
						<input matInput formControlName="localidad" />
					</mat-form-field>

					<mat-form-field appearance="outline">
						<mat-label>Partido</mat-label>
						<input
							matInput
							formControlName="partidoBusqueda"
							[matAutocomplete]="autoPartidos"
							placeholder="Buscar partido"
							autocomplete="off"
						/>
						<mat-autocomplete
							#autoPartidos="matAutocomplete"
							[displayWith]="displayPartido"
							(optionSelected)="onSeleccionarPartido($event.option.value)"
						>
							@for (partido of partidosFiltrados(); track partido.id) {
							<mat-option [value]="partido">{{ partido.description }}</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>

					<mat-form-field appearance="outline">
						<mat-label>Código Postal</mat-label>
						<input matInput type="number" formControlName="codPostal" />
					</mat-form-field>
				</div>

				<div class="address-form__grid-bottom">
					<mat-form-field appearance="outline">
						<mat-label>Torre</mat-label>
						<input matInput formControlName="torre" />
					</mat-form-field>

					<mat-form-field appearance="outline">
						<mat-label>Piso</mat-label>
						<input matInput formControlName="piso" />
					</mat-form-field>

					<mat-form-field appearance="outline">
						<mat-label>Departamento</mat-label>
						<input matInput formControlName="depto" />
					</mat-form-field>
				</div>
			</form>

			<div class="address-actions">
				@if (modoEdicionDomicilio()) {
				<button mat-raised-button class="btn-primary" (click)="guardarEdicionDomicilio()">
					<lucide-icon name="save" [size]="16" [strokeWidth]="1.5" color="#ffffff"></lucide-icon>
					Modificar
				</button>
				} @else {
				<button mat-raised-button class="btn-primary" (click)="agregarNuevoDomicilio()">
					<lucide-icon name="plus" [size]="16" [strokeWidth]="1.5" color="#ffffff"></lucide-icon>
					Confirmar
				</button>
				}
				<button mat-stroked-button class="btn-cancel" (click)="cancelarEdicion()">
					Cancelar
				</button>
			</div>
		</section>
		} @else {
		<!-- Botón para abrir formulario de agregar -->
		<button mat-stroked-button class="btn-add" (click)="mostrarFormAgregar.set(true)">
			<span class="btn-icon-label">
				<lucide-icon name="plus" [size]="16" [strokeWidth]="1.5" color="#5f1f7b"></lucide-icon>
				Agregar domicilio
			</span>
		</button>
		}

		}

	</mat-card-content>
</mat-card>
